import { getMe } from './me'
import { inStoreApp } from './store-app'
import { el } from './ui'
import { accessWords } from '../functions/lib/access-words'

// A paused or view-only round (billing stage 6, functions/lib/round-access.ts), said in one line under the top bar on
// every screen, so nobody wonders why adding a customer or sending a message didn't work. Owners on the web are told
// how to open it again (Your plan); inside the iPhone app nothing about paying is said (Apple 3.1.3). Workers are told
// what still works. Redrawn whenever the app hears from the server who is signed in.

export function drawAccessLine(): void {
  const me = getMe()
  const inApp = inStoreApp()
  const words = accessWords(me?.access, me?.role, inApp)
  const old = document.querySelector('.access-line')
  if (!words) { old?.remove(); return }
  const line = el('p', { class: 'access-line', role: 'status' }, words)
  if (me?.role === 'owner' && me.plan && !inApp) line.append(' ', el('a', { href: '#/plan' }, 'Open Your plan'))
  if (old) { old.replaceWith(line); return }
  document.querySelector('header.topbar')?.after(line)
}

let bound = false
export function watchAccessLine(): void {
  drawAccessLine()
  if (bound) return
  bound = true
  window.addEventListener('roundly:rounds-updated', drawAccessLine)
}
